<script>
import Layout from '@layouts/main'
import VehicleSearch from '@components/vehicle-search'
import { messages } from '@src/main'
import _ from 'lodash'

export default {
  page: {
    title: messages.en.pages.home.metaData.title,
    meta: [
      {
        name: 'description',
        content:
          'Purchase an AutoCheck vehicle history report. Be informed while shopping for a used car by exploring our reports, resources and tips.',
      },
      {
        name: 'keywords',
        content: 'Autocheck vehicle history report',
      },
      {
        name: 'viewport',
        content:
          'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.autocheck.com/vehiclehistory/',
      },
    ],
  },

  components: { Layout, VehicleSearch },
  props: {
    siteID: {
      type: String,
      required: false,
      default: '0',
    },
  },

  computed: {
    siteIDForBanner() {
      return _.get(this, '$store.state.referrer.referrerData.siteID', '0')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row" :class="$style.homeHero">
      <div class="container mt-4 mb-4">
        <div class="row">
          <div class="d-md-none d-block text-center">
            <img
              src="@assets/images/mobile-hero-wtext.jpg"
              class="w-100 mobile-hero-spacing"
              alt="AutoCheck Report Pages"
            />
            <h2>AutoCheck helps you buy and sell with confidence.</h2>
          </div>
          <div class="col-md-6 col-12">
            <VehicleSearch :search-type="{ plate: true, vin: true }" />
          </div>
        </div>
      </div>
    </div>
    <div class="container" :class="$style.getAnswers">
      <div class="row">
        <div class="col-md-6 mt-5 mb-5">
          <div
            v-html="$t('pages.home.contentSections.getAnswers.content')"
          ></div>
          <a v-scroll-to="'#searchVin'" href="#" class="d-block mb-4">
            <BaseButton type="button">Get AutoCheck Report</BaseButton>
          </a>
          <BaseLink :to="{ name: 'sample-report' }"
            >See Sample Reports >></BaseLink
          >
        </div>
        <div class="col-md-5 mt-5 mb-4">
          <img
            src="@assets/images/report-example-home.jpg"
            alt="AutoCheck Report Pages"
          />
        </div>
      </div>
    </div>
    <div class="container" :class="$style.autoCheckBenefits">
      <div class="row">
        <div class="col-12 cardContainer">
          <div class="row text-center">
            <div class="col-md-4 col-12 mb-3">
              <div class="cardContent">
                <h2>Scan Quickly</h2>
                <h3 class="titleBlue">The AutoCheck Score</h3>
                <img src="images/ScanQuickly238.png" alt="Scan Quickly" />
                <p>
                  Spot your perfect vehicle quickly with the patented AutoCheck
                  Score and minimize the risk of buying a vehicle with unseen
                  problems.
                </p>
                <BaseLink :to="{ name: 'autocheck-score' }">
                  <BaseButton button-type="buttonSecondary" type="button"
                    >Learn More</BaseButton
                  >
                </BaseLink>
              </div>
            </div>
            <div class="col-md-4 col-12 mb-3">
              <div class="cardContent">
                <h2>Dive in Deep</h2>
                <h3 class="titleBlue">Full Vehicle Histories</h3>
                <img
                  src="images/DiveInDeepReports204.png"
                  alt="Dive in Deeper"
                />
                <p>
                  Learn if a vehicle has been reported in an accident, branded a
                  lemon, damaged in a flood, reported repossessed or stolen, and
                  more.
                </p>
                <BaseLink :to="{ name: 'reports-list' }">
                  <BaseButton button-type="buttonSecondary" type="button"
                    >Learn More</BaseButton
                  >
                </BaseLink>
              </div>
            </div>
            <div class="col-md-4 col-12 mb-3">
              <div class="cardContent">
                <h2>Rest Easy</h2>
                <h3 class="titleBlue">Backed by Experian</h3>
                <img src="images/RestEasy178.png" alt="Buyback Protection" />
                <p>
                  Be confident in your purchase and enjoy access to benefits
                  such as free Buyback Protection for registered, qualified
                  vehicles.
                </p>
                <BaseLink :to="{ name: 'vehicle-buyback-protection' }">
                  <BaseButton button-type="buttonSecondary" type="button"
                    >Learn More</BaseButton
                  >
                </BaseLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-5">
      <div
        v-if="siteIDForBanner === '0' || siteIDForBanner === '2191'"
        class="row mb-4"
      >
        <div class="col-sm-6 d-inline-block"
          ><a
            href="https://www.keysavvy.com/partners/autocheck?aaId=exp&buyOrSell=buy?aaId=exp"
            target="_blank"
          >
            <img
              src="images/KeySavvy-AutoCheck-teamup-bnr.png"
              alt="Buying or selling your vehicle private party?"
          /></a>
        </div>
        <div class="col-sm-6 d-inline-block"
          ><a
            href="https://www.keysavvy.com/partners/autocheck/ev?aaId=exp"
            target="_blank"
          >
            <img
              src="images/KeySavvy-EV-tax-credit-bnr.png"
              alt="Apply the used EV tax credit when buying private party"
          /></a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <!--<h2>Partners</h2>-->
          <div class="text-center">
            <h3 class="titleBlue">
              AutoCheck is Proud to be Partnered with Leaders in the Automotive
              Industry
            </h3>
            <p>
              <img src="images/autotrader-logo.png" alt="AutoTrader" />
              <img src="images/cargurus-logo.png" alt="cargurus.com" />
              <img src="images/cars-logo.png" alt="Cars.com" />
              <img src="images/carzing-logo.png" alt="carzing.com" />
            </p>
            <p>
              <img src="images/ebay-logo.png" alt="eBay" />
              <img src="images/edmunds-logo.png" alt="Edmunds.com" />
              <img src="images/kbb-logo.png" alt="KBB.com" />
              <img
                src="images/J.D.-Power.png"
                width="117"
                height="20"
                alt="J.D. Power"
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.homeHero {
  @media screen and (min-width: 768px) {
    background-image: url('@assets/images/home-hero.jpg');
    background-repeat: no-repeat;
    background-position: 80% 40%;
    background-size: cover;
  }

  @media screen and (max-width: 768px) {
    padding-right: 15px;
    padding-left: 15px;
  }
}
.usersSaying {
  display: flex;
  flex-direction: column;
  > * {
    margin-top: auto;
  }
  h3 {
    margin-bottom: 1rem;
  }
}
.getAnswers {
  img {
    width: 100%;
  }
}
.autoCheckBenefits {
  h2 {
    margin-top: 1rem;
  }
  h3 {
    margin-top: 0.5rem;
  }
  img {
    height: 184px;
    margin: 1rem 0;
  }
}
.mobile-hero-spacing {
  margin: 55px 0 20px;
}
</style>
